

















import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'

@Component
export default class AtomLinkButton extends ComponentVue {
  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  fab!: boolean

  @Prop({ type: String, default: null })
  color!: string

  @Prop({ type: Boolean, default: false })
  smallFont!: boolean

  @Prop({ type: Boolean, default: false })
  loading!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Emit('click')
  onClick() {}

  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }
}
